module.exports = __webpack_public_path__ + "images/marketing/peeps/hillary_hall.jpg";